import { create } from 'zustand';
import { fabric } from 'fabric';

export type Tool = 
  | 'select' 
  | 'text' 
  | 'rectangle' 
  | 'circle' 
  | 'line' 
  | 'draw' 
  | 'highlighter' 
  | 'eraser' 
  | 'image'
  | 'signature';

interface EditorState {
  currentPage: number;
  totalPages: number;
  zoom: number;
  activeTool: Tool;
  selectedObjectId: string | null;
  
  // Fabric canvas references per page (pageIndex -> Canvas)
  fabricCanvases: Record<number, fabric.Canvas>;
  
  // Actions
  setCurrentPage: (page: number) => void;
  setTotalPages: (total: number) => void;
  setZoom: (zoom: number) => void;
  setActiveTool: (tool: Tool) => void;
  setSelectedObject: (id: string | null) => void;
  registerCanvas: (pageIndex: number, canvas: fabric.Canvas) => void;
  unregisterCanvas: (pageIndex: number) => void;
}

export const useEditorStore = create<EditorState>((set) => ({
  currentPage: 1,
  totalPages: 0,
  zoom: 1,
  activeTool: 'select',
  selectedObjectId: null,
  fabricCanvases: {},

  setCurrentPage: (page) => set({ currentPage: page }),
  setTotalPages: (total) => set({ totalPages: total }),
  setZoom: (zoom) => set({ zoom }),
  setActiveTool: (tool) => set({ activeTool: tool }),
  setSelectedObject: (id) => set({ selectedObjectId: id }),
  
  registerCanvas: (pageIndex, canvas) => set((state) => ({
    fabricCanvases: { ...state.fabricCanvases, [pageIndex]: canvas }
  })),
  
  unregisterCanvas: (pageIndex) => set((state) => {
    const newCanvases = { ...state.fabricCanvases };
    delete newCanvases[pageIndex];
    return { fabricCanvases: newCanvases };
  }),
}));
